<template>
  <div class="d-flex flex-column justify-center align-center">
    <v-icon x-large color="blue-grey lighten-2">mdi-bee</v-icon>
    <span class="text-subtitle-2 blue-grey--text text--darken-1">{{
      this.$t('people.user_not_found')
    }}</span>
    <span class="text-body-2 blue-grey--text">{{
      this.$t('people.empty_state_subtitle')
    }}</span>
  </div>
</template>
<script>
export default {
  name: 'EmptyState',
}
</script>
